import { endpoints } from "@/utils/common/requests/endpoints";
import { useAction } from "@/utils/useQuery/useAction";

/**
 * @typedef {Object} DeleteCrewMemberArg
 * @property {string} userId
 */

/**
 * @returns {import("@/utils/useQuery/useAction").ActionReturn<DeleteCrewMemberArg>}
 */
export function useDeleteCrewMember({ crewId }) {
	return useAction({
		url: (arg) => endpoints.crew.DELETE_MEMBER({ crewId, userId: arg.userId }),
		method: "delete",
	});
}
